import React, { useState, useEffect } from 'react';
import { fetchStudentFileTypes, uploadStudentFile } from '../utils/api';
import { mapErrorMessage } from '../utils/errorMapping';
import './_Modal.css';

const UploadFileModal = ({ studentId, onClose, onFileUploaded }) => {
    const [file, setFile] = useState(null);
    const [fileGroup, setFileGroup] = useState('');
    const [fileType, setFileType] = useState('');
    const [studentFileTypes, setStudentFileTypes] = useState({});
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');

    useEffect(() => {
        const getFileTypes = async () => {
            try {
                const response = await fetchStudentFileTypes();
                setStudentFileTypes(response.data);
            } catch (error) {
                setError(mapErrorMessage(error.message));
            }
        };
        getFileTypes();
    }, []);

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setMessage('');

        if (!file || !fileGroup || !fileType) {
            setError('Please fill in all fields.');
            return;
        }

        const formData = new FormData();
        formData.append('file', file);
        formData.append('file_group', fileGroup);
        formData.append('file_type', fileType);

        try {
            await uploadStudentFile(studentId, formData);
            setMessage('File uploaded successfully.');
            onFileUploaded();
            onClose();
        } catch (error) {
            setError(mapErrorMessage(error.message));
        }
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <button className="modal-close" onClick={onClose}>X</button>
                <h2>Upload File</h2>
                {error && <p className="error">{error}</p>}
                {message && <p className="message">{message}</p>}
                <p>Allowed file types: pdf, jpg, png, heic. Max size: 2MB.</p>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <select value={fileGroup} onChange={(e) => { setFileGroup(e.target.value); setFileType(''); }}>
                            <option value="">Select File Group</option>
                            {Object.entries(studentFileTypes).map(([id, group]) => (
                                <option key={id} value={id}>{group[0]}</option>
                            ))}
                        </select>
                    </div>
                    <div className="form-group">
                        <select value={fileType} onChange={(e) => setFileType(e.target.value)} disabled={!fileGroup}>
                            <option value="">Select File Type</option>
                            {fileGroup && studentFileTypes[fileGroup] &&
                                Object.entries(studentFileTypes[fileGroup]).map(([id, name]) => {
                                    if (id !== "0") {
                                        return <option key={id} value={id}>{name}</option>;
                                    }
                                    return null;
                                })
                            }
                        </select>
                    </div>
                    <div className="form-group">
                        <input type="file" onChange={handleFileChange} />
                    </div>
                    <div className="actions-centered">
                        <button type="button" onClick={onClose} className="cancel-button text-button">Cancel</button>
                        <button type="submit" className="submit-button text-button">Upload</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default UploadFileModal;